import { getMotionElement } from "../hooks/use-motion-elm.mjs";
function checkMotionIsHidden(instance) {
  var _a;
  const isHidden = ((_a = getMotionElement(instance.$el)) == null ? void 0 : _a.style.display) === "none";
  const hasTransition = instance.$.vnode.transition;
  return hasTransition && isHidden;
}
export {
  checkMotionIsHidden
};
